module.exports = __webpack_public_path__ + "static/don18-5a616670ce7c24c6157ba555ec039ff9.jpg";